/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface ConfirmUserParams {
  /** User verification code */
  token?: string;
}

export interface LoginGuestParams {
  token?: string;
}

/** @format int32 */
export enum ModelsRequestSource {
  IsClientApp = "IsClientApp",
  IsDashboard = "IsDashboard",
  IsMobileiOS = "IsMobileiOS",
  IsMobileAndroid = "IsMobileAndroid",
  IsCustomerSuccess = "IsCustomerSuccess",
}

export interface ModelsUserPreference {
  category?: string | null;
  name?: string | null;
  value: boolean;
}

export interface ProviderChallengePayload {
  /** E.g. Google */
  provider?: string;
  /** The OpenUp URL responsible for handling the login response */
  redirectUrl?: string;
}

export interface RegisterGuestUserAfterCheckInParams {
  /** Is this a medical checkin */
  isMedicalCheckin?: boolean;
}

export interface RequestBookSlotRequestV2 {
  expertId?: string | null;
  expertIdsToExclude?: string[] | null;
  recaptchaToken?: string | null;
  sessionContext?: string | null;
  tags: RequestTag[];
  /** @format date-time */
  time: string;
  timezone: string;
}

export interface RequestChangePasswordRequest {
  newPassword?: string | null;
  oldPassword?: string | null;
}

export interface RequestExchangeCodeForTokenRequest {
  code?: string | null;
  domain?: string | null;
  provider?: string | null;
  requestSource: ModelsRequestSource;
}

export interface RequestIdTokenRequest {
  idToken?: string | null;
  provider?: string | null;
}

/** Request object to authenticate user using login API */
export interface RequestLoginRequest {
  /**
   * @format password
   * @minLength 0
   * @maxLength 255
   */
  password: string;
  recaptchaToken?: string | null;
  /**
   * @format email
   * @minLength 1
   */
  userName: string;
}

export interface RequestRefreshTokenRequest {
  token?: string | null;
}

export interface RequestRegisterGuestUserRequest {
  acceptedMedicalDataProcessing: boolean;
  acceptedTermsAndConditions: boolean;
  email?: string | null;
  /** @format uuid */
  employerId?: string | null;
  firstName?: string | null;
  hasDeskJob?: boolean | null;
  isManager?: boolean | null;
  isPartner: boolean;
  lastName?: string | null;
  phoneNumber?: string | null;
  recaptchaToken?: string | null;
  /** @format int32 */
  yearOfBirth?: number | null;
}

export interface RequestRegisterUserRequest {
  acceptedMedicalDataProcessing: boolean;
  acceptedTermsAndConditions: boolean;
  email?: string | null;
  /** @format uuid */
  employerId?: string | null;
  firstName?: string | null;
  focusThemes?: string[] | null;
  hasDeskJob?: boolean | null;
  isManager?: boolean | null;
  isPartner: boolean;
  languageCode?: string | null;
  lastName?: string | null;
  password?: string | null;
  recaptchaToken?: string | null;
  redirectUri?: string | null;
  /** @format int32 */
  yearOfBirth?: number | null;
}

export interface RequestResetPasswordRequest {
  code?: string | null;
  password?: string | null;
  recaptchaToken?: string | null;
  /** Email */
  userId?: string | null;
}

export interface RequestSendBookingLoginEmailRequest {
  email?: string | null;
  psyUrlHandle?: string | null;
  recaptchaToken?: string | null;
}

export interface RequestSendPasswordResetEmailRequest {
  email?: string | null;
  recaptchaToken?: string | null;
  redirectUrl?: string | null;
}

export interface RequestTag {
  description?: string | null;
  tagName?: string | null;
  tagType?: string | null;
  translations?: string[] | null;
}

export interface RequestUpdatePhoneNumberRequest {
  /**
   * @format tel
   * @minLength 0
   * @maxLength 20
   */
  number: string;
}

export interface RequestUpdateUserRequest {
  acceptedMedicalDataProcessing: boolean;
  acceptedTermsAndConditions: boolean;
  /** @format uuid */
  employerId?: string | null;
  firstName?: string | null;
  hasDeskJob?: boolean | null;
  isManager?: boolean | null;
  isPartner?: boolean | null;
  isTranscriptionAllowed?: boolean | null;
  languageCode?: string | null;
  lastName?: string | null;
  phoneNumber?: string | null;
  signUpToNewsletter: boolean;
  /** @format int32 */
  yearOfBirth?: number | null;
}

export interface RequestUserConfirmationSignature {
  signature?: string | null;
}

export interface RequestUsersOtpLoginRequest {
  email?: string | null;
  password?: string | null;
}

export interface ResponseCreateUnconfirmedUserResponse {
  signature?: string | null;
  unconfirmedDataId?: string | null;
}

export interface ResponseExternalLoginRegisterCodeFlowResponse {
  twoFactorVerification?: string | null;
  userId?: string | null;
  userTokenProviders?: string[] | null;
}

export interface ResponseLoginCodeFlowResponse {
  twoFactorVerification?: string | null;
  userId?: string | null;
  userTokenProviders?: string[] | null;
}

/** @format int32 */
export enum ResponseOpenUpRole {
  Automation = "Automation",
  Guest = "Guest",
  Client = "Client",
  Psychologist = "Psychologist",
  Admin = "Admin",
  Manager = "Manager",
}

export interface ResponseTwoFactorNotEnforcedConsultResponse {
  canJoinVideoCall: boolean;
  chatThreadId?: string | null;
  clientEmail?: string | null;
  clientFirstName?: string | null;
  clientId?: string | null;
  clientTimezone?: string | null;
  clientUrl?: string | null;
  consultLanguage?: string | null;
  consultType?: string | null;
  employeeFullName?: string | null;
  employeeId?: string | null;
  employeeImageUrl?: string | null;
  /** @format int32 */
  employeeNumber: number;
  employeePersonalUrlHandle?: string | null;
  employeeThumbnailUrl?: string | null;
  /** @format int32 */
  id: number;
  roomId?: string | null;
  /** @format date-time */
  startedAt: string;
  status?: string | null;
  themeKey?: string | null;
}

export interface ResponseUserPreferenceResponse {
  category?: string | null;
  name?: string | null;
  value: boolean;
}

export interface ResponseUserResponse {
  /** @format date-time */
  createdAt: string;
  email?: string | null;
  /** @format uuid */
  employerId?: string | null;
  employerName?: string | null;
  firstName?: string | null;
  /**
   * Boolean indicating whether the user has a valid phone number associated with their account
   * Calculated at runtime.
   */
  hasValidPhoneNumber: boolean;
  id?: string | null;
  isEmailConfirmed: boolean;
  isFocusThemeSet: boolean;
  isGuestLogin: boolean;
  isManager: boolean;
  isPartner: boolean;
  isRegistered: boolean;
  isRegisteredWithPassword: boolean;
  isTranscriptionAllowed: boolean;
  languageCode?: string | null;
  lastName?: string | null;
  loginProvider?: string | null;
  phoneNumber?: string | null;
  phoneNumberConfirmed: boolean;
  preferences?: ResponseUserPreferenceResponse[] | null;
  roles?: ResponseOpenUpRole[] | null;
  signUpToNewsletter: boolean;
  twoFactorEnabled: boolean;
  /** List of external 2FA token providers set up by user */
  userTokenProviders?: string[] | null;
  /** @format int32 */
  yearOfBirth?: number | null;
}

export interface SendEmailVerificationParams {
  /** The email address to which this verification link will be sent */
  email?: string;
  /** The Uri where user should be redirected after verification of the email address */
  redirectUri?: string;
}

export type SetUserCurrentMoodsPayload = string[];

export type SetUserPreferencesPayload = ModelsUserPreference[];

export interface UpdateUserPhoneNumberWithTokenParams {
  token?: string;
}
